import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M992 992L32 32\" p-id=\"1867\" /><path d=\"M992 1024a32.128 32.128 0 0 1-22.656-9.344l-960-960A32 32 0 0 1 54.592 9.408l960 960A32 32 0 0 1 992 1024z\" p-id=\"1868\" /><path d=\"M32 992l960-960\" p-id=\"1869\" /><path d=\"M32 1024a32 32 0 0 1-22.656-54.592l960-960a32 32 0 0 1 45.248 45.248l-960 960A31.872 31.872 0 0 1 32 1024z\" p-id=\"1870\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol